import type { GetInvoicesHighlightsStatisticsResponse } from '@vy/api-definition';
import { GetInvoicesHighlightsStatisticsResponseSchema } from '@vy/api-definition';
import type { InvoiceDate, InvoiceFilter } from '@vy/types';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

type UseInvoicesHighlightsStatisticsParams = {
  customerId?: string;
  filters?: InvoiceFilter[];
  search?: string;
  issuedDates?: InvoiceDate[];
};

export function useInvoicesHighlightsStatistics(
  params: UseInvoicesHighlightsStatisticsParams = {},
  options?: UseQueryOptions<GetInvoicesHighlightsStatisticsResponse>,
) {
  const { customerId, filters, search, issuedDates } = params;

  return useQuery({
    queryKey: queryKeys.invoicesHighlightsStatistics(customerId, filters, search, issuedDates),
    queryFn: async () => {
      const api = getPrivateApi();
      const response = await api.getInvoicesHighlightsStatistics({
        customerId,
        filters: filters ? JSON.stringify(filters) : undefined,
        search,
        issuedDates: issuedDates ? JSON.stringify(issuedDates) : undefined,
      });

      return GetInvoicesHighlightsStatisticsResponseSchema.parse(response);
    },
    ...options,
  });
}
